/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePalSubmissionRequest
 */
export interface CreatePalSubmissionRequest {
    /**
     * PAL auth integration ID (required if is_non_submission_flow is false)
     * @type {string}
     * @memberof CreatePalSubmissionRequest
     */
    pal_auth_integration_id?: string;
    /**
     * Whether this is a non-submission flow
     * @type {boolean}
     * @memberof CreatePalSubmissionRequest
     */
    is_non_submission_flow?: boolean;
}

/**
 * Check if a given object implements the CreatePalSubmissionRequest interface.
 */
export function instanceOfCreatePalSubmissionRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreatePalSubmissionRequestFromJSON(json: any): CreatePalSubmissionRequest {
    return CreatePalSubmissionRequestFromJSONTyped(json, false);
}

export function CreatePalSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePalSubmissionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pal_auth_integration_id': !exists(json, 'pal_auth_integration_id') ? undefined : json['pal_auth_integration_id'],
        'is_non_submission_flow': !exists(json, 'is_non_submission_flow') ? undefined : json['is_non_submission_flow'],
    };
}

export function CreatePalSubmissionRequestToJSON(value?: CreatePalSubmissionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pal_auth_integration_id': value.pal_auth_integration_id,
        'is_non_submission_flow': value.is_non_submission_flow,
    };
}

